import { useMutation } from "@shared/lib/hooks";
import { ReportService } from "../../services/Report.servie";
import { ToastService } from "@shared/lib/services";

import { REPORTS_LIST_QUERY_KEY } from "../../constants";

interface IEditReportDataFieldsRequest {
  itemId: string;
  dataField: { [key: string]: string | number };
}

export function useEditReportDataFields(reportId: string) {
  const {
    mutate: editReportDataFields,
    isLoading: isEditing,
    isSuccess: isEdited,
  } = useMutation({
    mutationFn: (data: IEditReportDataFieldsRequest) =>
      ReportService.editReportDataFieldV2Data(
        data.itemId,
        data.dataField
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...REPORTS_LIST_QUERY_KEY, reportId],
      });
    },
  });

  return {
    editReportDataFields,
    isEditing,
    isEdited,
  };
}
